// @flow
import React, { Component } from "react";
import { Button, Checkbox, Dropdown, Form, Icon, Label, Modal } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import BrandSettingsFields from "./BrandSettingsFields";
import { UserInput } from "../../components";

class BrandDetail extends Component {
  state = {
    brand: {
      ...this.props.brand,
      button_label: !this.props.brand.button_label ? "Service" : this.props.brand.button_label,
      servicebox_wo_2: this.props.brand.servicebox_wo_2 || "",
      servicebox_wo_2_name: this.props.brand.servicebox_wo_2_name || "",
    },
    photo: "",
    errorNameText: "",
    errorVinPrefixText: "",
    errorButtonLabelText: "",
    errorServiceButtonTabletURL: "",
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(({ brand }) => ({ brand: { ...brand, [name]: value } }));
  };

  handleGroupChange = (_, { value }) => {
    this.setState(({ brand }) => ({ brand: { ...brand, brand_group_id: value } }));
  };

  handleCheckboxChange = (_, { name, checked }) => {
    this.setState(({ brand }) => ({ brand: { ...brand, [name]: checked } }));
  };

  handleNewBrandFileChange = event => {
    if (!event || !event.target || !event.target.files) {
      return;
    }
    this.setState({ photo: event.target.files[0] });
  };

  handleChangeComplete = color => {
    let { brand } = this.state;
    brand.color = color.hex;
    this.setState({ brand });
  };

  validateForm = () => {
    let { brand } = this.state;

    let errorNameText = "";
    let errorGroupText = "";
    let errorVinPrefixText = "";
    let errorServiceboxWoText = "";
    let errorServiceboxWo2Text = "";
    let errorServiceboxVinText = "";
    let errorButtonLabelText = "";
    let errorServiceButtonTabletURL = "";
    let urlRegex = /^https?:\/\/[a-z0-9]+([-.][a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)*$/;

    if (!brand.name || !brand.name.trim()) {
      errorNameText = this.props.t("this_field_is_required").message || "This field is required";
    }
    if (
      !errorNameText &&
      brand.country &&
      brand.country.trim() &&
      (this.props.brands || []).some(
        option =>
          option.id !== brand.id &&
          option.name.toLowerCase() === brand.name.trim().toLowerCase() &&
          (option.country || "").toLowerCase() === brand.country.trim().toLowerCase()
      )
    ) {
      errorNameText = this.props.t("brand_already_exists").message || "Brand already exists for this country";
    }
    if (!brand.vin_prefix || !brand.vin_prefix.trim()) {
      errorVinPrefixText = this.props.t("this_field_is_required").message || "This field is required";
    }
    if (!brand.brand_group_id) {
      errorGroupText = this.props.t("this_field_is_required").message || "This field is required";
    }
    if (brand.servicebox_wo) {
      if (!urlRegex.test(brand.servicebox_wo)) {
        errorServiceboxWoText = this.props.t("enter_valid_url").message || "Enter valid URL";
      }
    }
    if (brand.servicebox_wo_2) {
      if (!urlRegex.test(brand.servicebox_wo_2)) {
        errorServiceboxWo2Text = this.props.t("enter_valid_url").message || "Enter valid URL";
      }
    }
    if (brand.servicebox_vin) {
      if (!urlRegex.test(brand.servicebox_vin)) {
        errorServiceboxVinText = this.props.t("enter_valid_url").message || "Enter valid URL";
      }
    }
    if (brand.tablet_service_button_url) {
      if (!urlRegex.test(brand.tablet_service_button_url)) {
        errorServiceButtonTabletURL = this.props.t("enter_valid_url").message || "Enter valid URL";
      }
    }

    if (!brand.button_label || !brand.button_label.trim()) {
      errorButtonLabelText = this.props.t("this_field_is_required").message || "This field is required";
    }

    this.setState({
      errorVinPrefixText,
      errorNameText,
      errorGroupText,
      errorServiceboxWoText,
      errorServiceboxWo2Text,
      errorServiceboxVinText,
      errorButtonLabelText,
      errorServiceButtonTabletURL,
    });
    return (
      errorNameText.length === 0 &&
      errorGroupText.length === 0 &&
      errorVinPrefixText.length === 0 &&
      errorServiceboxWoText.length === 0 &&
      errorServiceboxWo2Text.length === 0 &&
      errorServiceboxVinText.length === 0 &&
      errorButtonLabelText.length === 0 &&
      errorServiceButtonTabletURL.length === 0
    );
  };

  handleSave = () => {
    let { brand, photo } = this.state;
    if (this.validateForm()) {
      this.props.onSave(brand, photo);
    }
  };

  render() {
    let {
      brand,
      errorNameText,
      errorGroupText,
      errorVinPrefixText,
      errorServiceboxWoText,
      errorServiceboxWo2Text,
      errorServiceboxVinText,
      errorButtonLabelText,
      errorServiceButtonTabletURL,
    } = this.state;

    return (
      <div className="BrandDetail">
        <Modal
          open={true}
          onClose={() => {
            this.props.onHideDetail();
          }}
          closeOnDimmerClick={false}
          size="small"
        >
          <Modal.Header className="brand-detail-modal-header">
            {this.props.mode === "create" ? this.props.t("add_new_brand").message || "Add new brand" : this.props.t("edit_brand").message || "Edit brand"}
            <Checkbox
              name="is_active"
              floated="right"
              checked={brand.is_active}
              onChange={this.handleCheckboxChange}
              label={this.props.t("active").message || "Active"}
            />
          </Modal.Header>

          <Modal.Content scrolling>
            <Form>
              <Form.Field>
                <label>{this.props.t("brand").message || "Brands"}</label>
                <UserInput type="text" name="name" onChange={this.handleChange} placeholder={this.props.t("Brand").message || "Brand"} value={brand.name} />
                {errorNameText && (
                  <Label basic color="red" pointing>
                    {errorNameText}
                  </Label>
                )}
              </Form.Field>
              <Form.Field>
                <label>{this.props.t("vin_nr").message || "Vin #"}</label>
                <UserInput type="text" name="vin_prefix" onChange={this.handleChange} value={brand.vin_prefix} placeholder={this.props.t("vin_nr").message || "Vin #"} />
                {errorVinPrefixText && (
                  <Label basic color="red" pointing>
                    {errorVinPrefixText}
                  </Label>
                )}
              </Form.Field>
              {this.props.mode !== "create" && (
                <Form.Field>
                  <label>{this.props.t("group").message || "Group"}</label>
                  <Dropdown
                    selection
                    fluid
                    search
                    clearable
                    name="brand_group_id"
                    options={this.props.brandGroupOptions}
                    value={brand.brand_group_id}
                    onChange={this.handleGroupChange}
                    placeholder={this.props.t("group").message || "Group"}
                  />
                  {errorGroupText && (
                    <Label basic color="red" pointing>
                      {errorGroupText}
                    </Label>
                  )}
                </Form.Field>
              )}
              <Form.Field>
                <label>{this.props.t("pon_brand_code").message || "PON Brand Code"}</label>
                <UserInput
                  type="text"
                  name="pon_brand_code"
                  onChange={this.handleChange}
                  value={brand.pon_brand_code}
                  placeholder={this.props.t("pon_brand_code").message || "PON Brand Code"}
                />
              </Form.Field>
              <BrandSettingsFields
                values={brand}
                errors={{ errorButtonLabelText, errorServiceButtonTabletURL, errorServiceboxWoText, errorServiceboxVinText, errorServiceboxWo2Text }}
                onChange={this.handleChange}
                onColorChange={this.handleChangeComplete}
                onFileChange={this.handleNewBrandFileChange}
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="red"
              disabled={this.props.loading}
              onClick={() => {
                this.props.onHideDetail();
              }}
              floated="left"
            >
              <Icon name="close" /> {this.props.t("discard").message || "DISCARD"}
            </Button>
            <Button color="green" onClick={this.handleSave} loading={this.props.loading} disabled={this.props.loading}>
              <Icon name="checkmark" /> {this.props.t("save").message || "SAVE"}
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(BrandDetail);
